import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Book from "@/pages/Book";
import ThankYou from "@/pages/ThankYou";
import Replay from "@/pages/Replay";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Disclaimer from "@/pages/legal/Disclaimer";
import useMetaPixelPageviews from "@/hooks/useMetaPixelPageviews";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  useMetaPixelPageviews();
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/book" element={<Book />} />
        <Route path="/discovery-call" element={<Book />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/thanks" element={<ThankYou />} />
        <Route path="/replay" element={<Replay />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({
      duration: 1.35,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.0,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0f0f12", color: "#F0ECE4", border: "1px solid rgba(201,168,76,0.35)" } }} />
    </>
  
  );
}

export default App;
